import { render } from "./resizer.vue?vue&type=template&id=e5c53c22"
import script from "./resizer.vue?vue&type=script&lang=js"
export * from "./resizer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__